import tw from "twin.macro";
export const PrimaryButton = tw.button`mt-3 px-8 py-3 font-bold bg-black text-white hocus:text-[#fc0606] focus:outline-none transition duration-300`;
